/**
 * Runtime Config Entry Item
 *
 * Picks the row editor for one RuntimeConfigDialog entry: the certificate-list
 * editor for `pem-ca-bundle` slots (System Trust Store, #180), the plain
 * file/env row for everything else. Both take the same row props.
 */

import type { ReactElement } from 'react';
import type { RuntimeConfigCtx } from '../../api/adminApi';
import type { RuntimeConfigEntry } from '../../schemas/admin.schemas';
import { RuntimeConfigEntryRow } from './RuntimeConfigEntryRow';
import { CaBundleEntryRow } from './CaBundleEntryRow';

interface RuntimeConfigEntryItemProps {
  featureId: string;
  ctx: RuntimeConfigCtx;
  entry: RuntimeConfigEntry;
  onSave: (value: string) => Promise<void>;
  onDelete: () => void;
  onRequestEdit: () => void;
  isSaving: boolean;
  isDeleting: boolean;
  editable: boolean;
  canDelete: boolean;
}

export function RuntimeConfigEntryItem({
  featureId,
  ctx,
  ...rowProps
}: RuntimeConfigEntryItemProps): ReactElement {
  if (rowProps.entry.format === 'pem-ca-bundle') {
    return <CaBundleEntryRow featureId={featureId} ctx={ctx} {...rowProps} />;
  }
  return <RuntimeConfigEntryRow {...rowProps} />;
}
